import { Routes, Route, Outlet, Navigate } from 'react-router-dom';

import DatafySwitchProvider from '~/shared/context/DatafySwitchProvider';

import FleetManagerPage from './components/FleetManagerPage';
import AutoscaleRulesPage from './components/FleetManagerPage/AutoscaleRulesPage/AutoscaleRulesPage';
import AllVolumesPage from './components/FleetManagerPage/AllVolumesPage/AllVolumesPage';
import VolumePage from './components/VolumePage/VolumePage';

function FleetManagerLayout() {
  return (
    <DatafySwitchProvider>
      <Outlet />
    </DatafySwitchProvider>
  );
}

export default function FleetManagerRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<FleetManagerLayout />}>
        <Route element={<FleetManagerPage />}>
          <Route index element={<Navigate to="autoscale-rules" replace />} />
          <Route path="autoscale-rules" element={<AutoscaleRulesPage />} />
          <Route path="all-volumes" element={<AllVolumesPage />} />
        </Route>
        <Route path=":id" element={<VolumePage />} />
      </Route>
    </Routes>
  );
}
